import { rawApiClient } from './api';

const headers = (token) => (token ? { 'x-auth-token': token } : {});

// Admin
export const listAdminRepresentations = async (token, includeInactive = false) => {
  const res = await rawApiClient.get('/admin/persona-representations', {
    params: includeInactive ? { includeInactive: 'true' } : {},
    headers: headers(token)
  });
  return res.data;
};

export const createRepresentation = async (token, payload) => {
  const res = await rawApiClient.post('/admin/persona-representations', payload, { headers: headers(token) });
  return res.data;
};

export const updateRepresentation = async (token, id, payload) => {
  const res = await rawApiClient.put(`/admin/persona-representations/${id}`, payload, { headers: headers(token) });
  return res.data;
};

export const deactivateRepresentation = async (token, id) => {
  const res = await rawApiClient.delete(`/admin/persona-representations/${id}`, { headers: headers(token) });
  return res.data;
};

// Client
export const listClientRepresentations = async (token, personaKey = null) => {
  const res = await rawApiClient.get('/client/representations', {
    params: personaKey ? { personaKey } : {},
    headers: headers(token)
  });
  return res.data;
};

export const setClientRepresentation = async (token, key) => {
  const res = await rawApiClient.put('/client/me/representation', { key }, { headers: headers(token) });
  return res.data;
};
